import request from "utils/request";
import { baseRequestURL } from "api/BaseAPI";
import { delay } from "utils/promise";

import { AibleClientFactory } from "client/aible/factory";

function getTestAnalytics() {
  const getRandom = (length = 1, isRaw = false, maxVal) => {
    const cap = maxVal ?? Math.pow(10, length);
    const val = Math.ceil(Math.random() * cap);
    if (isRaw) {
      return val;
    }
    let retVal = String(val);
    if (retVal.length < length);
    {
      while (retVal.length < length) {
        retVal = "0" + retVal;
      }
    }
    return retVal;
  };
  const date = `20${getRandom(2)}-${getRandom(2, undefined, 12)}-${getRandom(2, undefined, 28)}`;
  const time = `${getRandom(2, undefined, 23)}-${getRandom(2, undefined, 59)}-${getRandom(2, undefined, 59)}`;
  return {
    data: {
      chat_count: getRandom(4, true),
      combination_count: getRandom(7, true),
      dataset_column_count: getRandom(4, true),
      dataset_count: getRandom(2, true),
      dataset_row_count: getRandom(7, true),
      document_count: getRandom(2, true),
      document_set_count: getRandom(2, true),
      model_count: getRandom(3, true),
      total_document_size: getRandom(9, true)
    },
    id: `${date}-${time}-${getRandom(6)}`,
    status: "COMPLETE"
  };
}

export async function fetchAnalytics(accountId, skipCache = false) {
  // return delay(1000).then(() => Promise.resolve(getTestAnalytics()))

  const factory = await AibleClientFactory.getInstance().getAccountClient().getCustomerClientFactory(accountId);

  const completion = await factory.getAnalyticsClient().fetchAnalytics(skipCache);

  if (completion.status == "ERROR") {
    const errorMessage = completion.message ?? "There was an error generating the user activity for this account";

    if (completion.error && completion.error.type) {
      const errorCause = completion.error.type;

      throw Error(errorMessage, { cause: errorCause });
    } else {
      throw Error(errorMessage);
    }
  }

  return completion;
}
